import React, { useState, useEffect } from "react";
import { LineSeparator } from "../../components/separators";
import { THEME_COLORS, MEDIA_QUERIES } from "../../styles/theme";
import { Offer } from "../../components/Offer";
import { ENV_VARIABLES } from '../../envVariables';
import { BottomSheet } from "../../components/BottomSheet";
import { Accordion } from "../../components/Accordion";
import { AccordionChildFileDownload } from "../../components/Accordion/AccordionChildFileDownload";
import LogoRow from "../../components/LogoRow";
import ProgressionRow from '../../components/ProgressionRow';
import { BottomsheetTriggerContainer, BottomsheetTriggerTitle, BottomsheetTriggerSubTitle, BottomSheetHeaderText } from "../../components/BottomSheet/style";
import { AccordionContainer, Label, EntryContent, EntriesContainer, TitleSection, LegalNotes, LegalNotesContainer } from "./style";
import FormSectionTitle from "../../components/FormSectionTitle";
import { ForniturePage, PersonalDataPage, RecapPageI18n } from "../../i18n";
import { InputWrapper, InputWrapperHalf } from "../../components/FormContainer/components";
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES } from "../../reducers/supplyAddressForm"; 
import { SubmitButton } from "../../components/Buttons";
import { ROUTES, PAYMENT_METHODS } from "../../utils/constants";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "../../reducers/personalDataForm";
import { PAYMENT_RECAP_FIELD_NAMES } from "../../reducers/paymentRecap";
import { RECAP_REDUCER_FIELD_NAMES } from "../../reducers/recapReducer";
import { ChatCallContainer } from "../../components/ChatCallContainer";
import { InfoPopup } from "../ConsentsPage/InfoPopup";
import { LegalNotesText } from "./RecapPageTextsComponents";
import { setTrackerScript } from "../../tracking/setTracker";
import { getTrackingInfoOffer } from "../../tracking/getTrackingInfoOffer";
import { adfSendEvent } from "../../tracking/adfSendEvent";
import { CONSENT_FORM_FIELD_NAMES } from "../../reducers/consentForm";
import OfferBox from "../../components/OfferBox";
import {DataLayerContainerRecap} from "../../components/DataLayer";

export const RecapPage = (props) => {
    const { offer } = props;
    const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);
    const [popupContent, setPopupContent] = useState({ title: '', content: '' });
    const ProductAklamioArray = ENV_VARIABLES.ProductAklamioArray
    let ChatVisible = true
    if (offer.name.includes('VIVIpartner')  || ProductAklamioArray.includes(offer.offerId) )
    {
        ChatVisible = false
    }
    useEffect(() => {
        props.onChange(RECAP_REDUCER_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10));
    }, []);

    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|riepilogo' });
        }
    }, [offer]);

    return (
        <React.Fragment>
            <DataLayerContainerRecap {...props} />
            <div className="container" style={{ marginBottom: '200px' }}>

                <ChatCallContainer 
                    trackerChat={() => adfSendEvent('vivigas|x|funnel|riepilogo|click_chat')()}
                    trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|riepilogo|click_ti_chiamiamo_noi")()}
                    callMeSubmitStartTrackName='vivigas|x|funnel|riepilogo|click_conferma'
                    callMeSubmitSuccessTrackName="vivigas|x|funnel|riepilogo|thankyou_richiamami"
                    isCallMeVisible={ChatVisible}
                />

                <LogoRow />

                <InfoPopup
                    isOpen={isInfoPopupOpen}
                    closePopup={() => setIsInfoPopupOpen(false)}
                    content={popupContent}
                />

                <ProgressionRow backpath={ROUTES.consents} step={4} />

                <div className="row">
                    <div className="col col-xl-8">
                        <FormSectionTitle
                            title={PersonalDataPage.formTitle}
                            subtitle={PersonalDataPage.formSubtitle}
                            backpath={ROUTES.personalData}
                        />

                        <FormSectionTitle
                            title={ForniturePage.formTitle}
                            subtitle={ForniturePage.formSubtitle}
                            backpath={ROUTES.supply}
                        />

                        <FormSectionTitle
                            title={"RECAPITO E PAGAMENTO"}
                            subtitle={""}
                            backpath={ROUTES.paymentRecap}
                        />

                        <FormSectionTitle
                            title={"Consensi"}
                            subtitle={""}
                            backpath={ROUTES.consents}
                        />

                        <FormSectionTitle
                            title={"RIEPILOGO"}
                            subtitle={`Stai per concludere l'attivazione dell'offerta ${props.offer.name}. Controlla i dati inseriti e clicca su CONFERMA  per finalizzare l'acquisto. Per cambiare i dati inseriti clicca su MODIFICA nel passaggio relativo alle informazioni da modificare.`}
                            isActive={true}
                        />

                        <EntriesContainer>
                            <InputWrapper>
                                <div>
                                    <Label>Nome</Label>
                                    <EntryContent>{props.formPersonalData[PERSONAL_DATA_FORM_FIELDS_NAMES.name]}</EntryContent>
                                </div>
                            </InputWrapper>

                            <InputWrapper>
                                <div>
                                    <Label>Cognome</Label>
                                    <EntryContent>{props.formPersonalData[PERSONAL_DATA_FORM_FIELDS_NAMES.surname]}</EntryContent>
                                </div>
                            </InputWrapper>

                            <InputWrapper>
                                <div>
                                    <Label>Email</Label>
                                    <EntryContent>{props.formPersonalData[PERSONAL_DATA_FORM_FIELDS_NAMES.email]}</EntryContent>
                                </div>
                            </InputWrapper>

                            <InputWrapper>
                                <div>
                                    <Label>Cellulare</Label>
                                    <EntryContent>{props.formPersonalData[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone]}</EntryContent>
                                </div>
                            </InputWrapper>

                            <InputWrapper>
                                <div>
                                    <Label>Codice fiscale</Label>
                                    <EntryContent>{props.formPersonalData[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode]}</EntryContent>
                                </div>
                            </InputWrapper>
                        </EntriesContainer>

                        <LineSeparator />

                        <EntriesContainer>
                            <TitleSection>Indirizzo di fornitura</TitleSection>
                            <InputWrapper>
                                <div>
                                    <Label>Indirizzo</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]} {props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapper>
                                <div>
                                    <Label>Numero civico</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapper>
                                <div>
                                    <Label>Comune</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapperHalf>
                                <div>
                                    <Label>CAP</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap]}</EntryContent>
                                </div>
                            </InputWrapperHalf>
                            <InputWrapperHalf>
                                <div>
                                    <Label>Provincia</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province]}</EntryContent>
                                </div>
                            </InputWrapperHalf>
                            <InputWrapper>
                                <div>
                                    <Label>Attuale fornitore luce</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapper>
                                <div>
                                    <Label>POD</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapper>
                                <div>
                                    <Label>Attuale fornitore Gas</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]}</EntryContent>
                                </div>
                            </InputWrapper>
                            <InputWrapper>
                                <div>
                                    <Label>PDR</Label>
                                    <EntryContent>{props.formSupplyAddress[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]}</EntryContent>
                                </div>
                            </InputWrapper>
                        </EntriesContainer>

                        <LineSeparator />

                        <EntriesContainer>
                            {props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount ?
                                <React.Fragment>
                                    <InputWrapper>
                                        <div>
                                            <Label>IBAN</Label>
                                            <EntryContent>{props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.iban]}</EntryContent>
                                        </div>
                                    </InputWrapper>
                                    {!props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame] &&
                                        <React.Fragment>
                                            <InputWrapper>
                                                <div>
                                                    <Label>Nome</Label>
                                                    <EntryContent>{props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName]}</EntryContent>
                                                </div>
                                            </InputWrapper>
                                            <InputWrapper>
                                                <div>
                                                    <Label>Cognome</Label>
                                                    <EntryContent>{props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname]}</EntryContent>
                                                </div>
                                            </InputWrapper>
                                            <InputWrapper>
                                                <div>
                                                    <Label>Codice fiscale</Label>
                                                    <EntryContent>{props.formPaymentRecap[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode]}</EntryContent>
                                                </div>
                                            </InputWrapper>
                                        </React.Fragment>
                                    }
                                </React.Fragment>

                                :

                                <InputWrapper>
                                    <div>
                                        <Label>Addebito su bollettino</Label>
                                        <EntryContent>
                                            SI
                                        </EntryContent>
                                    </div>
                                </InputWrapper>
                            }


                        </EntriesContainer>

                        <LineSeparator />

                        <EntriesContainer>
                            <InputWrapper>
                                <div>
                                    <Label>Richiesta passaggio rapido</Label>
                                    <EntryContent>{props.consentForm[CONSENT_FORM_FIELD_NAMES.isFastSwitch] ? 'SI' : 'NO'}</EntryContent>
                                </div>
                            </InputWrapper>
                        </EntriesContainer>

                        <SubmitButton
                            mainColor={THEME_COLORS.blueViolet}
                            type="submit"
                            value="Conferma"
                            onClick={async e => {
                                //leggo il cookie di tc commander
                                let VivigasUIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                                console.log('VivigasUId', VivigasUIdCookie)
                                e.preventDefault();

                                try {
                                    await props.submit(true);
                                    window.tC.event.confirmStep(this, {stepId: 'funnel_step6', user_id : `"${VivigasUIdCookie}"`})
                                    console.log('tCEvent-> confirmStep funnel_step6')
                                    props.history.push('/richiesta-ricevuta');
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            disabled={props.recapReducer[RECAP_REDUCER_FIELD_NAMES.isSubmittingForm]}
                            errorText={props.recapReducer[RECAP_REDUCER_FIELD_NAMES.submittingFormError]}
                            onClickSaveAndContinueLater={async e => {
                                e.preventDefault();
                                try {
                                    await props.submit(false);
                                    window.tC.event.dropOffConDatiSaveAndResume();
                                    console.log('tCEvent-> dropOffConDatiSaveAndResume funnel_step6')
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            successText={props.recapReducer[PAYMENT_RECAP_FIELD_NAMES.successText]}
                        />

                        <LegalNotesContainer onClick={() => {
                            setPopupContent({ title: RecapPageI18n.legalNotesTitle, content: <LegalNotesText /> });
                            setIsInfoPopupOpen(true);
                        }}>
                            <LegalNotes>{RecapPageI18n.legalNotesTitle}</LegalNotes>
                        </LegalNotesContainer>

                        <AccordionContainer>
                            <Accordion />
                        </AccordionContainer>
                    </div>
                    <div className="col-xl-3">
                        <OfferBox {...props.offer} />
                    </div>
                </div>
            </div>
            <BottomSheet
                TriggerContent={
                    <BottomsheetTriggerContainer>
                        <div style={{ marginRight: '20px' }}>
                            <BottomsheetTriggerTitle>{props.offer.name}</BottomsheetTriggerTitle>
                            <BottomsheetTriggerSubTitle>VISUALIZZA I DETTAGLI</BottomsheetTriggerSubTitle>
                        </div>
                    </BottomsheetTriggerContainer>
                }
                HeaderContent={<BottomSheetHeaderText>CHIUDI I DETTAGLI</BottomSheetHeaderText>}
                backgroundColor="white"
                Content={<Offer {...props.offer} isMobile={true} />}
                maxExcludedScreenSize={MEDIA_QUERIES.desktop}
            />
        </React.Fragment>
    );
}